export default "/_next/static/images/tug-toy-2x-88d53d6632bb87adccaa3836418585b6.jpg";